import { Navigate, Outlet } from "react-router-dom";

export const RequireAuth = ({ auth }) => {
  if (!auth?.isLoggedIn) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return <Outlet />;
};